import { GlassSwitch } from "./GlassSwitch";
import { setLang, useLang, useT, type Lang } from "@/lib/i18n";
import { useStudioLanguages } from "@/features/studio/StudioRoot";

/** Russian / Kazakh interface switch on the same liquid glass as the tabs; hidden when the studio offers one language. */
export function LanguageSwitch() {
  const lang = useLang();
  const t = useT();
  const languages = useStudioLanguages();
  if (languages.length < 2) return null;
  return (
    <GlassSwitch<Lang>
      label={t.lang.label}
      value={lang}
      onChange={setLang}
      size="sm"
      fill={false}
      options={languages.map((l) => ({ value: l, label: t.lang[l] }))}
    />
  );
}
